// extracted by mini-css-extract-plugin
export var container = "spotlightCard-module--container---DfTD";
export var backdrop = "spotlightCard-module--backdrop--690dm";
export var slideUp = "spotlightCard-module--slideUp--SXPKg";
export var slideUpLarge = "spotlightCard-module--slideUpLarge--LNXa8";